module.exports = __webpack_public_path__ + "assets/404.556f14c7.svg";